/* eslint-disable for-direction */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import deleteIcon from '../../../assets/images/dashboard-business/deleteIcon.svg';
import { TInfo, TStep4Info } from '../../../types';
import { validateOwnersInput } from '../../../utils/validateOwnerInputs';
import AddPartnerForm from './AddPartnerForm';
import BusinessOwnerFilledForm from './BusinessOwnerFilledForm';
import BusinessOwnerForm from './BusinessOwnerForm';
import BusinessPartnerFilledForm from './BusinessPartnerFilledForm';
import { getFromLocalStorage } from '../../../utils/setRegInfoInLocalStorage';

type TProps = {
  step4Info: TStep4Info;
  setStep4Info: React.Dispatch<React.SetStateAction<TStep4Info>>;
  setPartners: React.Dispatch<React.SetStateAction<TStep4Info[]>>;
  setStep: React.Dispatch<React.SetStateAction<number>>;
  partners: TStep4Info[];
};
const BusinessOwnerShipInformation = ({
  setStep,
  setPartners,
  setStep4Info,
  step4Info,
  partners,
}: TProps) => {
  const [showAddPartnersForm, setShowAddPartnersForm] = useState(false);
  // const form1 = localStorage.getItem('form1');
  const form1 = getFromLocalStorage('form1');
  const step1Info: TInfo = form1 && JSON.parse(form1);
  const [invalidState, setInvalidState] = useState(false);

  const partnersNo = Number(step1Info.noOfPartners?.replace('partner ', ''));
  const [invalidOwnerState, setInvalidOwnerState] = useState(false);
  const [showingPartner, setShowingPartner] = useState(false);
  useEffect(() => {
    if (Object.keys(step4Info).length > 0 && !validateOwnersInput(step4Info)) {
      setInvalidOwnerState(true);
    } else if (partners.length > 0) {
      for (const obj of partners) {
        if (!validateOwnersInput(obj)) {
          setInvalidOwnerState(true);
          break;
        } else {
          setInvalidOwnerState(false);
        }
      }
    } else {
      setInvalidOwnerState(false);
    }
  }, [step4Info, partners]);

  return (
    <div className='md:w-[700px] mx-auto'>
      {step4Info?.gender ? (
        <BusinessOwnerFilledForm
          info={step4Info}
          setInfo={setStep4Info}
          setStep={setStep}
          showingPartner={showingPartner}
          partners={partners}
          setShowAddPartnersForm={setShowAddPartnersForm}
        />
      ) : (
        <BusinessOwnerForm
          info={step4Info}
          setInfo={setStep4Info}
          setStep={setStep}
          setShowAddPartnersForm={setShowAddPartnersForm}
          invalidOwnerState={invalidOwnerState}
        />
      )}
      {step1Info.structureOfBusiness === 'partnership' &&
        partners?.map((branch, index) => (
          <React.Fragment key={branch?.identityNumber}>
            <React.Fragment>
              <div className='flex justify-between flex-row md:w-full  mx-auto'>
                <h1 className='py-[40px] font-[500] md:text-[16px]'>{`Partner ${
                  index + 1
                } info`}</h1>

                <div
                  className='flex justify-end cursor-pointer items-center'
                  onClick={() => {
                    const Partners = partners.filter(
                      (branch_) => branch_.identityNumber !== branch.identityNumber,
                    );
                    setPartners(Partners);
                  }}
                >
                  <div className='flex justify-end cursor-pointer mr-[12px] '>
                    <img src={deleteIcon} alt={deleteIcon} className='h-[20px] w-[20px]' />
                  </div>
                  Delete Partner
                </div>
              </div>
            </React.Fragment>

            <BusinessPartnerFilledForm
              info={branch}
              setInvalidState={setInvalidState}
              invalidOwnerState={invalidOwnerState}
              setInfo={setPartners}
              partners={partners}
              index={index}
              setShowingPartner={setShowingPartner}
              showAddPartnersForm={showAddPartnersForm}
              setStep={setStep}
              setShowAddPartnersForm={setShowAddPartnersForm}
            />
          </React.Fragment>
        ))}
      {showAddPartnersForm && partners?.length < partnersNo && (
        <AddPartnerForm
          info={step4Info}
          setInfo={setStep4Info}
          setStep={setStep}
          setShowAddPartnersForm={setShowAddPartnersForm}
          addPartner={setPartners}
          partners={partners}
          invalidOwnerState={invalidOwnerState}
          setShowingPartner={setShowingPartner}
        />
      )}
    </div>
  );
};

export default BusinessOwnerShipInformation;
